export const theme = {
  base: {
    spacing: '12px',
    zIndex: {
      master: 999,
      senior: 90,
      junior: 80,
      fresher: 50
    },
    radius: '8px'
  },
  color: {
    black: {
      500: '#323232'
    },
    white: {
      500: '#fff'
    },
    gray: {
      200: '#f9f9f9',
      300: '#dbdbdb',
      400: '#c4c4c4'
    },
    green: {
      100: '#DBF8E8',
      200: '#B8F2D8',
      300: '#8BDABE',
      400: '#63B5A0',
      500: '#358477',
      600: '#26716C',
      700: '#1A5D5F',
      800: '#10454C',
      900: '#0A343F'
    },
    red: {
      400: '#EE6363'
    },
    yellow: {
      500: '#FAC172'
    },
    error: '#c20618'
  },
  modal: {
    bg: '#fff'
  },
  transition: {
    simple: 'all 0.2s ease-in-out'
  }
}
